<template>
  <div v-if="showAlertForSmallScreen" class="alert-small-screen">
    <p>This site is only supported on larger screens. Please use a desktop or maximize your browser window.</p>
  </div>
  <div class="faq-container">
    <div class="faq-title">Contact</div>
    <br>
    <div class="explanation-box-about">
      <p class="explanation-about">
        We welcome your questions, feedback, and bug reports. As the website is in its beta phase, your input is
        valuable in helping us improve. If you run into any issues, we kindly encourage you to share details and
        screenshots if available.
        <br><br>
        <span style="margin-top: 20px;"><b>Ali Akbari: </b><a class="resource" style="font-size: 16px; color: #A51C30; text-decoration: none;"
            href="mailto:&#097;&#108;&#105;&#095;&#097;&#107;&#098;&#097;&#114;&#105;&#064;&#104;&#109;&#115;&#046;&#104;&#097;&#114;&#118;&#097;&#114;&#100;&#046;&#101;&#100;&#117;">ali_akbari@hms.harvard.edu</a></span>
        <br>
        <span style="margin-top: 20px;"><b>David Reich: </b><a class="resource" style="font-size: 16px; color: #A51C30; text-decoration: none;"
            href="mailto:&#x72;&#x65;&#x69;&#x63;&#x68;&#x40;&#x67;&#x65;&#x6e;&#x65;&#x74;&#x69;&#x63;&#x73;&#x2e;&#x6d;&#x65;&#x64;&#x2e;&#x68;&#x61;&#x72;&#x76;&#x61;&#x72;&#x64;&#x2e;&#x65;&#x64;&#x75;">reich@genetics.med.harvard.edu</a></span>
        <br>
        <span style="margin-top: 20px;"><b>MohammadReza KarimiNejad: </b><a class="resource" style="font-size: 16px; color: #A51C30; text-decoration: none;"
            href="&#x6D;&#x61;&#x69;&#x6C;&#x74;&#x6F;&#x3A;&#x6D;&#x6F;&#x6B;&#x61;&#x72;&#x32;&#x30;&#x30;&#x31;&#x40;&#x67;&#x6D;&#x61;&#x69;&#x6C;&#x2E;&#x63;&#x6F;&#x6D;">mokar2001@gmail.com</a></span>


      </p>
      <br><br>
    </div>
  </div>
</template>

<script>
import { smallScreenMixin } from '@/mixins/smallScreenMixin';

export default {
  name: "About",
  mixins: [smallScreenMixin]
};
</script>

<style>
.faq-container {
  width: 945px;
  margin: 100px auto;
  text-align: left;
}

.faq-title {
  font-size: 24px;
  margin-top: 30px;
  font-weight: bold;
  margin-bottom: 20px;
}

.team-section {
  padding-left: 20px;
  margin-bottom: 20px;
}

.team-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

.main-team {
  list-style-type: none;
  padding-left: 0;
}

.main-team li {
  margin-bottom: 10px;
}

.acknowledgment-names {
  color: #555;
  line-height: 23px;
  text-align: justify;
  padding-left: 20px;
}

ul li {
  margin-left: 20px;
}

.alert-small-screen {
  font-size: 1.3rem;
  width: 90vw;
  margin: 0 auto;
  text-align: center;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.explanation-about {
  text-align: justify;
  line-height: 23px;
  position: relative;
  top: -20px;
  width: 945px;
}

.explanation-box-about {
  display: flex;
  justify-content: center;
  position: relative;
  padding: 0 !important;
}

mark {
  background-color: #e3e3e0;
  border-radius: 4px;
  padding: 0 2px;
}
</style>
